"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.realTypeOf = realTypeOf;
exports.isObject = isObject;
exports.isArray = isArray;
exports.isString = isString;
function realTypeOf(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}
function isObject(value) {
    return realTypeOf(value) === 'object';
}
function isArray(value) {
    return Array.isArray(value);
}
function isString(value) {
    return typeof value === 'string';
}
//# sourceMappingURL=real-type-of.js.map